module.exports = __webpack_public_path__ + "img/visa2.4cb1ffb3.png";